import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2524b7cv4g: FaireBrandEntity = {
  token: "b_2524b7cv4g",
  type: "brand",
  name: "Le Lolo",
  avatarUrl:
    "https://cdn.faire.com/fastly/065d79a59045a110a3e2fbdc4753658bff1b6223072bc871e7a906546a183741.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b6f550be597e840c526b211608eeec92209fe449b99469db223efb516218c4f9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/065d79a59045a110a3e2fbdc4753658bff1b6223072bc871e7a906546a183741.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b6f550be597e840c526b211608eeec92209fe449b99469db223efb516218c4f9.png",
  location: "Brooklandville, MD, USA",
  minimumOrderDollars: 180,
  rating: 5,
  reviewCount: 13,
  isInsider: true,
  description:
    "Le Lolo was created for mamas, by a mama, with a simple goal: to design beautiful, safe, and effective postpartum accessories that make every new mom feel beautiful, worthy, confident, and empowered. We understand that the postpartum journey can be challenging, often causing new moms to prioritize others over themselves. Our mission is to remind every new mama of her own beauty and worth by inspiring self-love and self-care through our accessories, helping her embrace this new chapter with confidence. At Le Lolo, we're here to celebrate and support every mom, ensuring she feels beautiful and empowered every step of the way. Our accessories are designed to remind every new mama of her strength and power as she navigates this incredible phase of life.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:02.108Z",
    importedBy: "entity-db-cli",
  },
};
